import { ListItem } from './lists.model';

export class ZSNResultType extends ListItem {}

export class ZSNConsoleModulationType extends ListItem {}
